// extracted by mini-css-extract-plugin
export default {"container":"VendorInvoice_Provider_container__oa48u","billingaddress":"VendorInvoice_Provider_billingaddress__9P3i4"};